import { AccountsManager } from '../components/AccountsManager';

/**
 * Contas Funded — contas virtuais que passaram da avaliação (FUNDED + LIVE),
 * divididas por mercado (B3 | Forex). Cada card tem busca própria e abre o
 * mesmo drawer de inspeção/ações. Dados via GET /admin/accounts (M3).
 */
export function AccountsFundedPage() {
  return (
    <div className="space-y-6">
      <div>
        <p className="text-2xs text-brand-500 font-semibold uppercase tracking-widest">Operação</p>
        <h1 className="font-display text-ink-900 mt-1 text-3xl font-semibold tracking-tight">
          Contas Funded
        </h1>
        <p className="text-ink-500 mt-1 text-sm">
          Traders aprovados na avaliação, operando com nosso capital (Funded e Live).
        </p>
      </div>

      <div className="grid gap-6 xl:grid-cols-2">
        <AccountsManager variant="funded" marketCode="B3" />
        <AccountsManager variant="funded" marketCode="FOREX" />
      </div>
    </div>
  );
}
